// extracted by mini-css-extract-plugin
module.exports = {"container":"i_j","icon":"i_k","title":"i_l","author":"i_m","price":"i_n","info":"i_o","button":"i_p","label":"i_q","exit":"i_r","ios":"i_s","android":"i_t"};